import { store } from 'store/configureStore';

/**
 * Returns the current controller's items. Single place that reads them from the store — its sole responsibility is
 * providing this data, so if the source ever changes (e.g. off Redux) only this function is updated, not its callers.
 * @returns {Array} controller items (empty array when none)
 */
export const getControllerItems = () => {
    const { serial, data } = store.getState().ezlo;

    return data?.[serial]?.items || [];
};
